import React from 'react';
import HarbourIcon from './HarbourIcon';
import './harbour.css';

/*
 * Harbour/Notice: info (plum tint), success, error, warning. One piece of
 * news per notice. Error and warning notices are announced to assistive tech.
 */
const KIND_ICON = {
  info: 'info',
  success: 'check-circle',
  error: 'error',
  // Attention, not failure: an exclamation, never the error cross.
  warning: 'warning',
};

export default function HarbourNotice({ kind = 'info', title, children, onClose, className = '' }) {
  const role = kind === 'error' || kind === 'warning' ? 'alert' : 'status';
  return (
    <div role={role} className={`harbour-notice harbour-notice--${kind} ${className}`.trim()}>
      <span className="harbour-notice__icon">
        <HarbourIcon name={KIND_ICON[kind]} size={20} />
      </span>
      <div className="flex-1 min-w-0">
        {title && <p className="harbour-notice__title">{title}</p>}
        {children && <div className="harbour-body-16">{children}</div>}
      </div>
      {onClose && (
        <button type="button" className="harbour-notice__close" onClick={onClose} aria-label="Close this message">
          <HarbourIcon name="close" size={20} />
        </button>
      )}
    </div>
  );
}
